import { render, staticRenderFns } from "./OlympicsStep2Modal.vue?vue&type=template&id=0f458f48&scoped=true&"
import script from "./OlympicsStep2Modal.vue?vue&type=script&lang=js&"
export * from "./OlympicsStep2Modal.vue?vue&type=script&lang=js&"
import style0 from "./OlympicsStep2Modal.vue?vue&type=style&index=0&id=0f458f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f458f48",
  null
  
)

export default component.exports